export const FACEBOOK_URL = "https://www.facebook.com/amdecorsignsandprints";
export const WHATSAPP_NUMBER = "447533082238";
export const WHATSAPP_URL = "https://wa.me/447533082238";
export const EBAY_URL = "https://www.ebay.co.uk/usr/amdecorprints";

const STOREFRONT = "https://www.amdecorsignsandprints.co.uk";

const CONTEXT_MESSAGES = {
  "/": "Hi — I'm browsing your storefront and would like to know more about your print and signage services.",
  "/canvas-category-landing": "Hi — I'm interested in your canvas print range. Could you help me pick the right size and finish?",
  "/canvas-prints": "Hi — I'm browsing your canvas collection. Can you help me choose?",
  "/wall-murals-landing": "Hi — I'm looking at wall murals. I'd like a quote for my wall dimensions.",
  "/collections/wall-murals": "Hi — I'm browsing your mural designs. Can you help with sizing and pricing?",
  "/stickers-labels": "Hi — I need stickers or labels produced. Can you help with a quote?",
  "/banners": "Hi — I need a banner quote. Can you help with sizing and materials?",
  "/vehicle-graphics": "Hi — I'm interested in vehicle graphics for my business. Can we discuss options?",
  "/custom-order-landing": "Hi — I have a custom project in mind. Can we discuss what's possible?",
  "/request-quote": "Hi — I'm filling out a quote request and had a quick question before I submit.",
};

export function getWhatsAppUrl(pathname, productContext) {
  let msg;

  if (productContext) {
    msg = productContext;
  } else {
    const base = Object.keys(CONTEXT_MESSAGES)
      .sort((a, b) => b.length - a.length)
      .find((key) => pathname.startsWith(key) && key !== "/");
    msg = CONTEXT_MESSAGES[base] || CONTEXT_MESSAGES["/"];
  }

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

export function getCanvasWhatsAppUrl(title, size, frame) {
  const parts = [`Hi — I'm looking at "${title}"`];
  if (size) parts.push(`in ${size}`);
  if (frame && frame !== "Unframed") parts.push(`with ${frame}`);
  parts.push(". Can you confirm availability and turnaround?");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(parts.join(" "))}`;
}
